import { Colors, getString } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import render from './render'

export default {
  name: 'Dot',

  props: {
    icon: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },
    color: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    tooltip: {
      type: [ String, Number, Boolean ],
      default: undefined
    }
  },

  computed: {
    $_directives() {
      const result = []
      const tooltip = getString(this.tooltip)
      if (tooltip) {
        result.push({
          name: components.tooltip,
          options: { value: tooltip }
        })
      }

      return result
    }
  },

  render
}

